import Quill from 'quill';
import 'quill-paste-smart';

export class Counter {
    private quill;
    private options;
    private container;
    constructor(quill, options) {
        this.quill = quill;
        this.options = options;
        this.container = document.querySelector(options.container);
        quill.on(Quill.events.EDITOR_CHANGE, this.update.bind(this));
    }

    calculate() {
        const text = this.quill.getText();
        const trimmed = text.replace(/\s/g, '');
        return trimmed.length;
    }

    update() {
        const length = this.calculate();
        let label = this.options.unit;
        if (length > 1) {
            label += 's';
        }
        let max = '';
        if(this.options.max !== undefined && !Number.isNaN(this.options.max) && this.options.max !== 0) {
            max = ' / ' + this.options.max;
            if(length > this.options.max && !this.container.className.includes('quill-counter-error')) {
                this.container.classList.add('quill-counter-error');
            }
            if(length <= this.options.max && this.container.className.includes('quill-counter-error')) {
                this.container.classList.remove('quill-counter-error');
            }
        }
        this.container.innerText = `${length} ${label} ${max}`;
    }
}

Quill.register('modules/counter', Counter);

const Block   = Quill.import('blots/block') as any;

export class titreH1 extends Block {
    static blotName = 'titre1';
    static tagName = 'div';
    static className = 'h1-admin-light';
}
Quill.register(titreH1);

export class titreH2 extends Block {
    static blotName = 'titre2';
    static tagName = 'div';
    static className = 'h2';
}
Quill.register(titreH2);

export class titreH3 extends Block {
    static blotName = 'titre3';
    static tagName = 'div';
    static className = 'h3';
}
Quill.register(titreH3);


export const QUILL_ADMIN_TOOLBAR = [
    ['bold', 'italic', 'underline', 'strike'],
    ['clean'],
    [{ list: 'bullet' }, { list: 'ordered'}],
    [{ script: 'sub'}, { script: 'super' }],
    [{ align: [] }],
    ['titre1', 'titre2', 'titre3'],
    [{ size: ['small', false, 'large', 'huge'] }],
    [{ color: ['black', '#444', '#888', '#bbb', '#E3007D', '#004AE5', '#BE0014', '#662482', '#000C99','#3BA836', '#05D5BA'] }],
    ['link']
];

export const QUILL_FAQ_TOOLBAR = [
    ...QUILL_ADMIN_TOOLBAR, ['image']
];

export const QUILL_DOSSIER_TOOLBAR = [
    ['bold', 'italic', 'underline', 'strike'],
    ['clean'],
    [{ list: 'bullet' }, { list: 'ordered'}],
    [{ script: 'sub'}, { script: 'super' }],
    ['titre1', 'titre2', 'titre3'],
];


export const QUILL_ADMIN_CONFIG = {
    toolbar: {
        container: QUILL_ADMIN_TOOLBAR,
        handlers: {
            titre1: titreH1,
            titre2: titreH2,
            titre3: titreH3
        }
    },
    counter: {
        container: '#default-counter',
        unit: 'caractère',
        max: 0
    },
    clipboard: {
        allowed: {
            tags: ['b', 'strong', 'u', 's', 'i', 'p', 'br', 'ul', 'ol', 'li', 'span', 'div', 'em'],
            attributes: ['class', 'style']
        },
        keepSelection: true,
        magicPasteLinks: true
    },
};

export const QUILL_FAQ_CONFIG = {
    toolbar: {
        container: QUILL_FAQ_TOOLBAR,
        handlers: {
            titre1: titreH1,
            titre2: titreH2,
            titre3: titreH3
        }
    },
    counter: {
        container: '#default-counter',
        unit: 'caractère',
        max: 0
    }
};


export const QUILL_DOSSIER_CONFIG = {
    toolbar: {
        container: QUILL_DOSSIER_TOOLBAR,
    },
    counter: {
        container: '#default-counter',
        unit: 'caractère',
        max: 0
    },
    clipboard: {
        allowed: {
            tags: ['b', 'strong', 'u', 's', 'i', 'p', 'br', 'ul', 'ol', 'li', 'span'],
            attributes: []
        },
        keepSelection: true,
        substituteBlockElements: true,
        magicPasteLinks: true
    },
};
